export default {
    blockSize: 0,
    repeatingWordsAccuracy: 0.0,
    ignoreWhitespaceDifferences: false,
};
//# sourceMappingURL=MatchOptions.js.map